var map = {
	"./auction.png": "e782",
	"./car.png": "5ee7",
	"./contract.png": "74d8",
	"./delivery.png": "3abe",
	"./procedures.png": "3da9",
	"./repair.png": "11c3",
	"./transport.png": "3b11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d792";